import { Form, Input } from "decorator-form";
import { v4 as generateUuid } from "uuid";

import InputType from "common/form/InputType";
import PanelGeneralConfig from "core/components/editor/panels/PanelGeneralConfig";

@Form({title: "Page"})
export default class PageConfig extends PanelGeneralConfig {

	@Input({type: InputType.TEXT, title: "Path"})
	public path: string = generateUuid();

	@Input({type: InputType.TEXT, title: "Title"})
	public title: string = "New Page";

	@Input({type: InputType.TEXT, title: "Label"})
	public label: string = "New Page";

	@Input({type: InputType.TEXT, title: "Icon"})
	public icon: string;

	@Input({type: InputType.PANELS, title: "Children"})
	public children: string[] = [];

	@Input({type: InputType.ROLES, title: "Roles allowed"})
	public rolesAllowed: string[];

	@Input({type: InputType.GROUPS, title: "Groups allowed"})
	public groupsAllowed: string[];

	@Input({type: InputType.TEXT, title: "Redirect"})
	public redirect?: string;
}



// WEBPACK FOOTER //
// ./src/panels/page/PageConfig.ts